import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["tab", "panel"];
  static values = { active: String };

  connect() {
    this._sync();
  }

  show(event) {
    const tab = event.currentTarget.dataset.tab;
    if (!tab) return;

    this.activeValue = tab;
    this._sync();
  }

  _sync() {
    this.tabTargets.forEach((el) => {
      const isActive = el.dataset.tab === this.activeValue;
      el.setAttribute("aria-selected", isActive ? "true" : "false");
      el.classList.toggle("bg-white", isActive);
      el.classList.toggle("shadow-sm", isActive);
      el.classList.toggle("font-semibold", isActive);
      el.classList.toggle("text-gray-modern-900", isActive);
      el.classList.toggle("bg-transparent", !isActive);
      el.classList.toggle("font-medium", !isActive);
      el.classList.toggle("text-gray-modern-500", !isActive);
    });

    this.panelTargets.forEach((el) => {
      const show = el.dataset.panel === this.activeValue;
      el.classList.toggle("hidden", !show);
    });
  }
}
